// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");

function getNodes(result) {
  return $$Array.map((function (edge) {
                return edge.node;
              }), result.edges);
}

exports.getNodes = getNodes;
/* No side effect */



// WEBPACK FOOTER //
// ./src/utils/Graphql.js